module.exports = __webpack_public_path__ + "static/media/toggleOn.ab8bfffb.svg";